<!--审核专家入库申请弹框-->
<template>
  <a-modal width="90vw"
           centered
           :footer="false"
           :closable="false"
           :visible="modalVisible"
           :destroyOnClose="true">
    <div style="margin: -24px">
      <expert-info-detail-component :expertInfo="expertInfo">
        <template slot="content">
          <div v-if="readonly">
            <div class="zjmp_t3">
              审核人：
              <div>{{ pendingAuditApplyForData.auditUserName }}</div>
            </div>
            <div class="zjmp_t3">
              审核时间：
              <div>{{ pendingAuditApplyForData.auditDate | dateFormat }}</div>
            </div>
            <div class="zjmp_t3">
              审核结果：
              <a-tag :color="AuditStateEnum.getValOrCol(pendingAuditApplyForData.auditState).color">
                {{ AuditStateEnum.getValOrCol(pendingAuditApplyForData.auditState).value }}
              </a-tag>
            </div>
            <div class="zjmp_t3"
                 v-if="pendingAuditApplyForData.auditState == AuditStateEnum.REFUSE[0]">
              不通过原因：
              <div>{{ pendingAuditApplyForData.auditFailReason }}</div>
            </div>
          </div>
          <div v-else>
            <a-form-model ref="auditForm"
                          :model="pendingAuditApplyForData"
                          :rules="rules"
                          :label-col="labelCol"
                          :wrapper-col="wrapperCol">
              <a-form-model-item label="是否同意"
                                 prop="auditState">
                <a-radio-group v-model="pendingAuditApplyForData.auditState">
                  <a-radio value="1">同意入库</a-radio>
                  <a-radio value="2">不同意入库</a-radio>
                </a-radio-group>
              </a-form-model-item>
              <template v-if="pendingAuditApplyForData.auditState === AuditStateEnum.APPROVE[0]">
              <a-form-model-item label="标签名称" prop="tagId">
                <a-radio-group v-model="pendingAuditApplyForData.tagId">
                  <a-radio-button v-for="item in tagList" :value="item.id"><b :style="'color:'+item.tagColor">{{
                      item.tagName
                    }}</b></a-radio-button>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item label="应急状态">
                <dict-radio dict-key="expert_emergency" v-model="pendingAuditApplyForData.emergencyFlag"></dict-radio>
              </a-form-model-item>
              </template>
              <a-form-model-item label="不同意原因"
                                 prop="auditFailReason"
                                 v-if="pendingAuditApplyForData.auditState === AuditStateEnum.REFUSE[0]">
                <a-input v-model="pendingAuditApplyForData.auditFailReason"
                         placeholder="请填写不通过原因"
                         type="textarea"
                         :auto-size="{ minRows: 4 }"/>
              </a-form-model-item>
            </a-form-model>
            <a-row :gutter="[12, 8]"
                   type="flex"
                   justify="center">
              <a-col :span="12">
                <a-button :loading="submitLoading"
                          @click="onSubmitApplyFor"
                          type="primary"
                          block>提交
                </a-button>
              </a-col>
            </a-row>
          </div>
        </template>
        <template slot="action">
          <a-button type="danger"
                    @click="onClose()">
            <a-icon type="close"/>
          </a-button>
        </template>
      </expert-info-detail-component>
    </div>
  </a-modal>
</template>

<script>
import ExpertInfoDetailComponent from '@epp/expertmain/expertInfo/ExpertInfoDetailComponent'
import { GetPendingAuditApplyForById, SubmitAuditApplyFor } from '@/epp/expertmain/pendingauditapplyfor/api/ApplyForApi'
import { AuditStateEnum } from '@/epp/expertmain/pendingauditapplyfor/util/ApplyForUtil'
import DictRadio from '@/components/dict/DictRadio.vue'
import { GetAllTagList } from '@/epp/expertmain/experttag/util/TagUtil'

export default {
  name: 'AuditExpertStorageApplyFor',
  components: {
    DictRadio,
    ExpertInfoDetailComponent
  },
  data () {
    return {
      AuditStateEnum: AuditStateEnum,
      submitLoading: false,
      readonly: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      rules: {
        auditState: [{ required: true, message: '请选择是否同意', trigger: 'change' }],
        auditFailReason: [{ required: true, message: '请输入不同意原因', trigger: 'blur' }],
      },
      modalVisible: false,
      expertInfo: {
        extras: {}
      },
      pendingAuditApplyForData: {},
      tagList: []
    }
  },
  created () {
    //获取标签列表
    this.getAllTagList()
  },
  methods: {
    async getAllTagList () {
      try {
        this.tagList = await GetAllTagList()
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    /**
     * 初始化数据
     * @param pendingAuditApplyForId 待审核申请表ID
     */
    async initData (pendingAuditApplyForId, readonly) {
      const res = await GetPendingAuditApplyForById(pendingAuditApplyForId)
      const result = res.result
      if (res.code == 200 && result) {
        this.pendingAuditApplyForData = result.pendingAuditApplyForData
        if (!readonly) {
          this.pendingAuditApplyForData.auditState = AuditStateEnum.APPROVE[0]
        }
        this.pendingAuditApplyForData.emergencyFlag = '0'
        this.expertInfo = result.expertInfo
        this.readonly = readonly
        this.modalVisible = true
      } else {
        this.$error({
          title: '此申请不存在',
        })
      }
    },
    onSubmitApplyFor () {
      this.$refs.auditForm.validate(valid => {
        if (valid) {
          this.handleSubmitApplyFor()
        } else {
          return false
        }
      })
    },
    async handleSubmitApplyFor () {
      this.submitLoading = true
      const res = await SubmitAuditApplyFor(this.pendingAuditApplyForData)
      if (res.code == 200) {
        this.$message.success('处理成功')
        this.modalVisible = false
        this.$emit('submitSuccess')
      }
      this.submitLoading = false
    },
    onClose () {
      this.modalVisible = false
    },
  },
}
</script>

<style lang="less" scoped>
.link {
  color: rgb(24, 144, 255);
}

.action button {
  margin-right: 4px;
}

.card {
  margin-bottom: 24px;

  .extras {
    font-weight: 500;
    font-size: 16px;
  }
}

.nav {
  .title {
    text-align: center;
    font-weight: 800;
  }

  .footer {
    text-align: right;
  }
}

.titleCap {
  margin-bottom: 12px;

  .receiveNum {
    padding-left: 16px;
  }

  > span {
    border-right: 1px solid #e6e6e6;
    padding: 0 20px;
  }

  > span:nth-last-child(1) {
    border-right: none;
  }

  > span:nth-child(2) {
    padding-left: 0;
  }
}
</style>
